// Настройки (UX-вайрфрейм, экран 05): только громкости звуков и музыки.
// Ползунки — общий VolumeControls (их же показывает пауза уровня).

import { SubHeader } from '@/meta/Shell';
import { VolumeControls } from '@/meta/VolumeControls';

export function SettingsScreen() {
  return (
    <main className="meta-screen" data-testid="screen-settings">
      <SubHeader title="Настройки" />
      <div className="meta-body">
        <div className="settings-card">
          <VolumeControls />
          <p className="hint">Применяется сразу — и в меню, и в уровнях.</p>
        </div>
      </div>
    </main>
  );
}
